import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'config/axios';

import { setErrors, setReportCompanies, setSingleReport, setLatestReportDate } from '../../../stores/modules/ecs/reportreducer';

export const fetchReports = async (params) => {
  try {
    const updatedParams = { ...params, page: params.page, limit: params.limit };
    if (params.search) {
      updatedParams.search = params.search;
    }
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/reports`, {
      params: updatedParams,
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchReportCompanies = createAsyncThunk('company/fetchReportCompanies', async (params, { dispatch }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_IDP_COMPANY_ENDPOINT_URL}/companies`, {
      params: params,
    });
    dispatch(setReportCompanies(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const updateReportStatus = createAsyncThunk('report/updateReport', async ({ idToken, reportId, reportStatus }, { dispatch }) => {
  try {
    const data = { reportStatus };
    const response = await axios.put(
      `${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/report/${reportId}`,
      data,
      {
        'Content-Type': 'application/json',
      }
    );
    return response.status;
  } catch (error) {
    return error?.response?.data?.message;
  }
});

export const updateRequestReport = async ({ payload }) => {
  try {
    let response = await axios.post(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/report`, payload, {
      headers: {
        'x-app-slug': 'crs',
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchReportIds = createAsyncThunk('report/fetchReportIds', async (idToken, { dispatch }) => {
  try {
    const params = { project: "_id,reportId" };
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/reports`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchReportsByID = createAsyncThunk('report/fetchReportsByID', async ({ id, idToken }, { dispatch }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/report/${id}`);
    dispatch(setSingleReport(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const downloadReport = async (reportId) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_PDF_ENDPOINT_URL}/excel_doc/${reportId}`);
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchLatestReportDate = createAsyncThunk('data/fetchLatestReportDate', async ({ idToken, params }, { dispatch }) => {
  try {
    dispatch(setLatestReportDate(null));
    dispatch(setErrors([]));
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/latest-report-date`, {
      params: params,
    });
    dispatch(setLatestReportDate(response.data.date));
  } catch (error) {
    dispatch(setErrors(error?.response?.data?.message));
    dispatch(setLatestReportDate(null));
  }
});

export const fetchReportDates = async ({ idToken, params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/report-dates`, {
      params: params,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};

export const fetchReportsQuery = async ({ idToken, reportId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/reports/query`,
      {
        params: { reportId }
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const uploadFiles = async (reportId, data) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_CRS_ALERTS_ENDPOINT_URL}/alerts/${reportId}`, data, {
      'Content-Type': 'multipart/form-data'
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchPDFReports = async () => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/pdf-reports`, {
      params: {
        limit: 'null'
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchPDFReportsBYID = async ({ selectedReportId }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/pdf-report/${selectedReportId}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchPPTReports = async ({ params }) => {
  try {
    const updatedParams = { ...params, page: params.page, limit: params.limit };
    if (params.search) {
      updatedParams.search = params.search;
    }
    let response = await axios.get(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/ppt-reports`, {
      params: updatedParams,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updatePPTReports = async ({ reportId, formData }) => {
  try {
    let response = await axios.post(`${process.env.REACT_APP_CRS_REPORT_ENDPOINT_URL}/ppt-report/${reportId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
